const queryString = require('query-string');
import axios from 'axios';

let searchBarMixin = {
    data() {
        return {
            page: 0, // start on 0 so first load loads page 1
            results: [],
            types: [],
            highlightedTypes: [],
            type: '',
            destinations: [],
            highlightedDestinations: [],
            destination: '',
            firstLoadDone: false
        }
    },
    computed: {
        searchData() {
            let searchData = {};

            if (this.notUndefinedNullOrBlankString(this.destination)) {
                searchData.destination = this.destination;
            }

            if (this.notUndefinedNullOrBlankString(this.type)) {
                searchData.type = this.type;
            }

            if (this.notUndefinedNullOrBlankString(this.stars)) {
                searchData.stars = this.stars;
            }

            if (this.notUndefinedNullOrBlankString(this.sort)) {
                searchData.sort = this.sort;
            }

            return searchData;
        },
        destinationLabel() {
            if (this.destinations[this.destination] !== undefined) {
                return this.destinations[this.destination];
            }
            if (this.highlightedDestinations[this.destination] !== undefined) {
                return this.highlightedDestinations[this.destination];
            }
            return '';
        },
        typeLabel() {
            if (this.types[this.type] !== undefined) {
                return this.types[this.type];
            }
            if (this.highlightedTypes[this.type] !== undefined) {
                return this.highlightedTypes[this.type];
            }
            return '';
        },
    },
    methods: {
        async getResults() {
            if (this.loading === false) {
                this.loading = true;
                this.apiError = false;
                this.page = this.page + 1;

                let urlParams = this.searchData;
                urlParams.page = this.page;
                let url = '/api/search?' + queryString.stringify(urlParams);

                try {
                    await axios.get(
                        url,
                        {
                            headers: {
                                'content-type': 'application/x-www-form-urlencoded'
                            }
                        }
                    ).then((response) => {
                        let data = response.data;
                        this.totalListings = data.TotalListingsCount;

                        if (data.ListingsCount > 0) {
                            this.results.push.apply(this.results, data.Listings);
                        }

                        this.allListingsShown = data.AllListingsShown;

                        this.destinations = data.Destinations;
                        this.highlightedDestinations = data.HighlightedDestinations;
                        if (!(this.destination in this.destinations) && !(this.destination in this.highlightedDestinations)) {
                            this.destination = '';
                        }

                        this.types = data.Types;
                        this.highlightedTypes = data.HighlightedTypes;
                        if (!(this.type in this.types) && !(this.type in this.highlightedTypes)) {
                            this.type = '';
                        }

                        this.maxStarRatingAmongListings = data.Stars;
                        if (this.stars > this.maxStarRatingAmongListings) {
                            this.stars = this.maxStarRatingAmongListings;
                        }

                        this.loading = false;
                        this.firstLoadDone = true;
                    });

                } catch (err) {
                    if (err.response) {
                        // The client was given an error response (5xx, 4xx)
                        console.log('The client was given an error response (5xx, 4xx)');
                    } else if (err.request) {
                        // The client never received a response, and the request was never left
                        console.log('The client never received a response, and the request was never left');
                    } else {
                        // Anything else
                        console.log('Other error');
                    }
                    this.loading = false;
                    this.apiError = true;
                }
            }
        },
        notUndefinedNullOrBlankString(value) {
            return (value !== undefined && value !== null && value !== '');
        },
    }
}

export default searchBarMixin;